import { MESSAGE_TYPES } from 'components';
import { addMessage } from 'store/actions/app';
import { keyValueMirror } from 'store/store-functions';

const {
    VITE_API_DEV_HOST,
    VITE_AUTHENTICATION_HOST,
    VITE_CLIENT_ID: clientId,
} = process.env;

const baseUrl = VITE_API_DEV_HOST;

export const actions = [
    'UPDATE_CREATOR_ID_ADMIN',
];

const keyActions = keyValueMirror(...actions);

export const updateCreatorIdAdmin = (token, creatorId, creatorData) => async dispatch => {
    const { displayName, allowedSubscriptionFormats, allowedPurchaseFormats } = creatorData;
    const url = `${baseUrl}/admin/creators/${creatorId}`;
    const options = {
        method: 'PUT',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            display_name: displayName,
            search_name: displayName.replaceAll(' ', '_'),
            allowed_subscription_formats: allowedSubscriptionFormats,
            allowed_purchase_formats: allowedPurchaseFormats,
        }),
    };

    try {
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            if (res.status === 400) {
                const message = 'Bad request sent for updating creator';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
            }

            const message = 'Unable to update creator. Status: ' + res.status;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const data = await res.json();
        const action = { type: keyActions.UPDATE_CREATOR_ID_ADMIN, payload: data };
        dispatch(action);
    } catch (err) {
        const message = 'Error updating creator';
        const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
        dispatch(addMessage([ { message, config } ]));

    }
};
